
import { getIcon } from '~/utils/get-icon.js'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    metaInformation: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    details() {
      return [
        {
          label: this.subtitle,
          value: this.title,
        },
        {
          label: this.$gettext('Location'),
          value: this.metaInformation.location,
        },
        {
          label: this.$gettext('Date and time'),
          value: this.$formatAsDate(this.metaInformation.dateTime, 'dateTime'),
        },
        {
          label: this.$gettext('End time'),
          value: this.metaInformation.endTime,
        },
      ]
    },

    formLink() {
      const { label, externalLink } = this.metaInformation.formLink

      return {
        label,
        href: externalLink,
      }
    },

    applyIcon() {
      return getIcon('edit')
    },
  },
}
